import { ServiceNonExistentError } from './exceptions/exceptions';

export class Guard {
	public static serviceExists(service: any) {
		if (!service) {
			throw new ServiceNonExistentError();
		}
	}
}
